export const DEFAULT_TECHNICIAN = -1;

export interface UserInfo {
  name: string;
  displayName: string;
  username: string;
  email: string;
  avatar: UserAvatar;
  roles: UserRoles[];
  tags: string[];
  orgId: number;
  id: number;
  account?: AccountInfo;
  info: Info;
  removed: boolean;
}

export enum UserRoles {
  Admin = 'admin',
  Manager = 'manager',
  Agent = 'agent',
  Root = 'root',
}

export interface Info {
  phone: string;
}

export interface UserRights {
  _id: number;
  roles: UserRoles[];
  agent_id: number;
  org_id: number;
  children: boolean
  hierarchy: number[];
}

export interface AccountInfo {
  agent_id: number;
  password: string;
  type: string;
  username: string;
}

export interface UserInfoResponse {
  display_name: string;
  email: string;
  glympse: {
    avatar_url: string;
    device_id: string;
    password: string;
    username: string;
  };
  hierarchy: string[];
  name: string;
  org_id: number;
  roles: UserRoles[];
  tags: string[];
  username: string;
  _id: number;
  account?: AccountInfo;
  info: {
    phones: UserPhone[];
  };
  removed?: boolean;
}

export interface UserPhone {
  type: string;
  number: string;
}

export interface UserAvatar {
  file?: ArrayBuffer;
  url?: string;
  type?: string;
}

export interface UserPasswordPayload {
  password?: string;
  passwordConfirm?: string;
}

export interface AgentUpdatePayload {
  tags?: string[];
  username?: string;
  foreign_id?: string;
}

export interface UserPayload {
  name: string;
  phone: string;
  email: string;
  tags?: string[];
  roles?: UserRoles[];
  avatar?: UserAvatar;
  organization?: number;
}

const mapResponseOnUserInfo = (data: UserInfoResponse): UserInfo => {
  if (!data) {
    return {} as UserInfo;
  }

  const removed = data.removed || false;

  return {
    name: removed ? `${ data.name } (removed)` : data.name,
    displayName: removed ? `${ data.display_name } (removed)` : data.display_name,
    username: data.username,
    email: data.email,
    avatar: {
      url: data.glympse ? data.glympse.avatar_url : '',
      file: null
    },
    roles: data.roles,
    orgId: data.org_id,
    id: data._id,
    tags: data.tags,
    account: data.account,
    info: {
      phone: data.info?.phones?.find(value => value?.type === 'cell')?.number,
    },
    removed,
  };
};

export default mapResponseOnUserInfo;
